export default "__VITE_ASSET__Bf_54zbe__"